var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',_vm._b({attrs:{"src":_vm.imgixUrl,"srcset":`${_vm.imgixUrl} 1x, ${_vm.imgixUrl}&dpr=2&q=30 2x, ${_vm.imgixUrl}&dpr=2&q=30 3x`,"loading":"lazy"}},'img',_vm.mainProps,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }